import { invoiceDataApi } from 'entities/invoice/details/api';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';


export const useSetLegalEntityTax = (invoiceId: number) => {
  const [update, { isLoading, error }] = invoiceDataApi.useSetInvoiceLegalEntityTaxMutation();
  return {
    setLegalEntityTax: (legalEntityTax: number) => update({ invoiceId, legalEntityTax }).unwrap(),
    isLoading,
    error: extractNestJsErrorMessage(error),
  };
};
